import React, { useRef } from 'react';
import Modal from '../shared/Modal';
import { FiLoader } from 'react-icons/fi';

const DowngradeConfirmModal = ({ open, onClose, onConfirm, upgrading, currentPlanData, freePlanData }) => {

    const cancelRef = useRef(null);
    const confirmRef = useRef(null);

    if (!open) return null;

    // Modal actions
    const modalActions = (
        <>
            <button
                ref={cancelRef}
                type="button"
                onClick={onClose}
                className="cancel-btn flex-1 px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 font-semibold rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
            >
                Annuler
            </button>
            <button
                type="button"
                ref={confirmRef}
                onClick={onConfirm}
                disabled={upgrading}
                className="flex-1 px-4 py-2 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition disabled:bg-red-400 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
                {upgrading ? (
                    <>
                        <FiLoader className="animate-spin" aria-hidden="true" />
                        <span>Annulation...</span>
                    </>
                ) : (
                    "Confirmer l'annulation"
                )}
            </button>
        </>
    );

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Annuler votre abonnement ?"
            actions={modalActions}
            initialFocusRef={confirmRef}
        >
            <div className="space-y-4 mb-6">
                <p className="text-sm text-gray-600 dark:text-gray-400">
                    Vous êtes sur le point de passer du plan <strong className="text-gray-900 dark:text-white">{currentPlanData?.name}</strong> au plan <strong className="text-gray-900 dark:text-white">Gratuit</strong>.
                </p>
                <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-red-800 dark:text-red-300 mb-2">
                        ⚠️ Conséquences de l'annulation :
                    </h4>
                    <ul className="text-sm text-red-700 dark:text-red-400 space-y-2">
                        <li className="flex items-start gap-2">
                            <span className="text-red-500 mt-0.5">•</span>
                            <span>Votre abonnement Stripe sera <strong>annulé immédiatement</strong></span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-red-500 mt-0.5">•</span>
                            <span>Vous perdrez l'accès aux fonctionnalités premium (exports/imports, mentions, notifications, etc.)</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-red-500 mt-0.5">•</span>
                            <span>Les limites du plan gratuit s'appliqueront : {freePlanData?.features?.slice(0, 2).join(', ')}</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-red-500 mt-0.5">•</span>
                            <span>Aucun remboursement ne sera effectué pour la période en cours</span>
                        </li>
                    </ul>
                </div>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                    Vous pourrez toujours souscrire à nouveau à un plan payant plus tard si vous changez d'avis.
                </p>
            </div>
        </Modal>
    );
};

export default DowngradeConfirmModal;
